module.exports = __webpack_public_path__ + "static/media/linkedin.e3f33402.png";